var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.ready
    ? _c(
        "div",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-select", {
                    attrs: {
                      value: _vm.value.Options[0],
                      label: _vm.$ct("operator"),
                      items: _vm.operators,
                      fancy: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setOperator($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("app-human-filter-edit-value", {
            attrs: {
              xs: "12",
              md: "6",
              filter: _vm.valueFilter,
              "field-type": _vm.fieldType,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }